// @flow

import {loadStripe} from '@stripe/stripe-js';
import {THEMES, LOCATIONS} from './constants';

export type State = {|
  theme: string,
  location: string,
  clientSecret: string,
  stripePromise: Promise<any>,
|};

export type Action =
  | {|
      kind: 'THEME_CHANGED',
      theme: string,
    |}
  | {|
      kind: 'LOCATION_CHANGED',
      location: string,
    |}
  | {|
      kind: 'SECRET_CHANGED',
      clientSecret: string,
    |};

export type Dispatch = (action: Action) => void;

export const reducer = (state: State, action: Action): State => {
  switch (action.kind) {
    case 'THEME_CHANGED': {
      const {theme} = action;
      if (theme === state.theme) {
        return state;
      }
      return {
        ...state,
        theme,
      };
    }

    case 'LOCATION_CHANGED': {
      const {location} = action;
      if (location === state.location) {
        return state;
      }
      return {
        ...state,
        location,
        clientSecret: '',
        stripePromise: loadStripe(LOCATIONS[location].publicKey),
      };
    }

    case 'SECRET_CHANGED': {
      const {clientSecret} = action;
      return {
        ...state,
        clientSecret,
      };
    }

    default: {
      return state;
    }
  }
};

export const getInitialState = (): State => {
  return {
    theme: THEMES.default.key,
    location: LOCATIONS.us.key,
    clientSecret: '',
    // Since Payment Element is still in beta, will use a hardcoded key for now.
    // This key need to match the key used for API call: pjsevason+klarna-test@stripe.com test DE account
    // Can probably update to useAccount()'s publishbale key later.
    stripePromise: loadStripe(LOCATIONS[LOCATIONS.us.key].publicKey),
  };
};
